import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
export const DownloadCVDiv = styled.span`
    /* padding-top: .5rem; */
    position: absolute;
    cursor: move;
    z-index: 999;
    right: 0;
    display: inline-block;
    padding: 1rem;
    margin: .5rem;
    background-color: ${({ theme }) => theme.color.third};
    border-radius:10px;
    box-shadow: 0 0 10px 5px ${({ theme }) => theme.color.first};
    a:hover{
        color: ${({ theme }) => theme.color.first};
    }
`